import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { cardsApi } from '@/services/rest/apiInstances';
import { CardResponse } from '@/api/general';
import { buildClientApiConfig } from '@/helpers/apiRequestConfig';

export const fetchCardsList = createAsyncThunk('cards/fetchCardsList', async () => {
    try {
        const options = buildClientApiConfig();
        const data = await cardsApi.viewCards({}, options);
        return data.data;
    } catch (error: any) {
        return error.data;
    }
});

export interface ICardsState {
    isPending: boolean;
    errors: any;
    cardsList: any[];
    isOpenSendDetailsModal: boolean;
    cardToDisplay: any;
    isOpenCardDetailsModal: boolean;
    cardDetailsToDisplay: CardResponse | undefined;
}

const initialState: ICardsState = {
    isPending: false,
    errors: null,
    isOpenSendDetailsModal: false,
    cardToDisplay: undefined,
    cardsList: [],
    isOpenCardDetailsModal: false,
    cardDetailsToDisplay: undefined,
};

export const cardsSlice = createSlice({
    name: 'cards',
    initialState,
    reducers: {
        openSendDetailsModal: (state, action: PayloadAction<any>) => {
            state.isOpenSendDetailsModal = true;
            state.cardToDisplay = action.payload;
        },
        closeSendDetailsModal: (state) => {
            state.isOpenSendDetailsModal = false;
            state.cardToDisplay = undefined;
        },
        openCardDetailsModal: (state, action: PayloadAction<any>) => {
            state.isOpenCardDetailsModal = true;
            state.cardDetailsToDisplay = action.payload;
        },
        closeCardDetailsModal: (state) => {
            state.isOpenCardDetailsModal = false;
            state.cardDetailsToDisplay = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCardsList.pending, (state) => {
                state.isPending = true;
            })
            .addCase(fetchCardsList.rejected, (state, action) => {
                state.isPending = false;
                state.errors = action.error;
            })
            .addCase(fetchCardsList.fulfilled, (state, action) => {
                const cards = action.payload?.cards;

                state.isPending = false;
                if (cards) {
                    state.cardsList = cards;
                }
            });
    },
});

export const {
    openSendDetailsModal,
    closeSendDetailsModal,
    openCardDetailsModal,
    closeCardDetailsModal,
} = cardsSlice.actions;

export default cardsSlice.reducer;
